import type { WidgetArticleDetailDefaultProps } from 'components/partials/widget/article-detail/default/default';
import type { WidgetArticleDetailHeadProps } from 'components/partials/widget/article-detail/head/head';
import Image from 'components/UI/Image/Image';
import { Title } from 'components/UI/Title';
import { createImage } from 'tests/utils';
import { WidgetTeaserStandard } from '../../teaser/standard';
import AutonativeArticleDetailDefault from './articleDetail/article-detail-default';
import AutonativeArticleDetailHead from './articleDetail/article-detail-head';
import { createTeaser } from './autonative-index';
import styles from './default.module.scss';

const mockArticleContent: WidgetArticleDetailDefaultProps = {
  type: 'page',
  template: 'article-widget',
  id: '1',
  items: [
    {
      id: '1',
      type: 'storyline_headline',
      model: {
        createdAt: '2023-08-24T13:52:59',
        publishedAt: '2023-08-24T13:52:59',
        homeSection: 'Stars',
        id: '85e9594a-4285-11ee-a5b5-43d7b3f68bf0',
        type: 'storyline_headline',
        fields: {
          headline: {
            value: 'This is a headline',
            annotations: [],
          },
          subtitle: {
            value: 'This is a Paragraph text ',
            annotations: [],
          },
          level: 'level',
          value: 'value',
          title: 'title',
          body: 'body',
        },
        title: 'Gamescom 2023',
        lastmodifiedAt: '2023-08-29T09:03:34',
        url: 'https://www.aws-sandbox.rtl.de/incoming/Gamescom-2023-id85e9594a-4285-11ee-a5b5-43d7b3f68bf0.html',
      },
    },
    {
      id: '2',
      type: 'storyline_subheadline',
      model: {
        createdAt: '2023-08-24T13:52:59',
        publishedAt: '2023-08-24T13:52:59',
        homeSection: 'Stars',
        id: '85e9594a-4285-11ee-a5b5-43d7b3f68bf0',
        type: 'storyline_headline',
        fields: {
          headline: {
            value: 'This is a sub-headline',
            annotations: [],
          },
          level: 'level',
          value: 'value',
          title: 'title',
          body: 'body',
        },
        title: 'Gamescom 2023',
        lastmodifiedAt: '2023-08-29T09:03:34',
        url: 'https://www.aws-sandbox.rtl.de/incoming/Gamescom-2023-id85e9594a-4285-11ee-a5b5-43d7b3f68bf0.html',
      },
    },
    {
      id: '3',
      type: 'storyline_paragraph',
      model: {
        createdAt: '2023-08-24T13:52:59',
        publishedAt: '2023-08-24T13:52:59',
        homeSection: 'Stars',
        id: '85e9594a-4285-11ee-a5b5-43d7b3f68bf0',
        type: 'storyline_headline',
        fields: {
          paragraph: {
            value:
              'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.',
            annotations: [],
          },
          level: 'level',
          value: 'value',
          title: 'title',
          body: 'body',
        },
        title: 'Gamescom 2023',
        lastmodifiedAt: '2023-08-29T09:03:34',
        url: 'https://www.aws-sandbox.rtl.de/incoming/Gamescom-2023-id85e9594a-4285-11ee-a5b5-43d7b3f68bf0.html',
      },
    },
  ],
};

export const WidgetAutonativeDetail = () => {
  const mockHeadContext: WidgetArticleDetailHeadProps = {
    items: [
      {
        id: '123',
        model: {
          image: createImage({
            baseUrl: 'https://dummyimage.com/1200x400/000/fff.jpg&text=imageDesktop',
            filename: 'sport-women-655353_1920',
          }),
          fields: {
            title: 'Article title',
            subtitle: 'Article Kickertext ',
          },
          lastmodifiedAt: '2023-02-15T12:07:46',
        },
      },
    ],
  };

  return (
    <div className="native-teaser-segment">
      <div className={`${styles.presenter} native-article-detail__presenter`}>
        <span className={styles.headline}>Präsentiert von</span>
        <Image alt={'präsentiert von'} width={80} src={'https://dummyimage.com/80x45/000/fff.jpg&text=dummy-image'} />
      </div>
      <div className="native-teaser__headline-link">
        <Title
          link={{
            url: '#',
            target: '_self',
            type: 'external-link',
          }}
          plainLink
        >
          Placeholder Headline
        </Title>
      </div>
      <AutonativeArticleDetailHead context={mockHeadContext} isSponsored />
      <div className="native-article-body">
        <AutonativeArticleDetailDefault context={mockArticleContent} />
      </div>

      <WidgetTeaserStandard
        context={{
          model: {
            fields: {
              title: 'Placeholder headline',
              link: {
                url: '#',
                target: '_self',
              },
            },
          },
          items: Array.from(Array(3), (_, index: number) => createTeaser({ id: `${index + 1}` })),
        }}
      />
    </div>
  );
};
